import { isNonEmptyArray, isNonEmptyDateRange } from './commons';

const formatFilterParams = (panelFilters = {}) => {
  const { createdAt, createdBy, updatedAt, updatedBy } = panelFilters;
  const filterParams = {};

  if (isNonEmptyDateRange(createdAt)) {
    filterParams.createdTime = createdAt.map(
      (time) => time?.toISOString?.() ?? '',
    );
  }

  if (isNonEmptyArray(createdBy)) {
    filterParams.createdBy = createdBy;
  }

  if (isNonEmptyDateRange(updatedAt)) {
    filterParams.updatedTime = updatedAt.map(
      (time) => time?.toISOString?.() ?? '',
    );
  }

  if (isNonEmptyArray(updatedBy)) {
    filterParams.updatedBy = updatedBy;
  }

  return filterParams;
};

export default formatFilterParams;
